<template>
    <div class="page" style="background-color: #ffffff;width: 100%;height: 100%">
      <van-nav-bar
        title="员工业绩明细"
        left-text="返回"
        left-arrow
        fixed
        @click-left="historyBack"
      ></van-nav-bar>
      <div style="padding: 0px;width: 100%;text-align: center;margin-top: 55px;margin-bottom: 10px">
        <el-radio-group v-model="tabPosition" size="mini" @change="perfClick">
          <el-radio-button label="1">今天</el-radio-button>
          <el-radio-button label="2">本月</el-radio-button>
          <el-radio-button label="3">上月</el-radio-button>
        </el-radio-group>
      </div>
      <el-table :data="staffCommDetals" border style="width: 100%" height="calc(100% - 7rem)">
          <el-table-column prop="projectname" label="项目名称" align="center" width="120"></el-table-column>
          <el-table-column prop="accountdate" label="日期" align="center">
            <template slot-scope="scope">
              {{$moment(scope.row.accountdate).format('YYYY-MM-DD')}}
            </template>
          </el-table-column>
          <el-table-column prop="perf" label="业绩" align="center"></el-table-column>
          <el-table-column prop="comm" label="提成" align="center"></el-table-column>
      </el-table>
    </div>
</template>
<script>
export default {
  data() {
    return {
      height:window.innerHeight-70,
      tabPosition: "1",
      active: "first",
      staffCommDetals: [],
      storeid: "",
      staffid: "",
      fromdate:this.$moment().format("YYYY-MM-DD"),
      todate:this.$moment().format("YYYY-MM-DD"),
    }
  },
  created: function () {
    this.storeid=localStorage.getItem("storeid");
    this.staffid=localStorage.getItem("staffid");
    this.getStaffSalaryById();
  },
  methods:{
    perfClick(e){
      if(e=="1"){
        this.fromdate=this.$moment().format("YYYY-MM-DD");
        this.todate=this.$moment().format("YYYY-MM-DD");
      }
      else if(e=="2"){
        this.fromdate=this.$moment().startOf('month').format('YYYY-MM-DD');
        this.todate=this.$moment().endOf('month').format('YYYY-MM-DD');
      }
      else if(e=="3"){
        let days=this.$moment(this.$moment().format('YYYY-MM-')+'01').startOf('month').subtract(1, 'days').format('YYYY-MM');
        this.fromdate=days+"-01";
        this.todate=days+"-"+this.$moment(this.fromdate, "YYYY-MM-DD").daysInMonth();
      }
      this.getStaffSalaryById();
    },
    getStaffSalaryById(){
      this.$post("/calsalary/getStaffSalaryById",{storeid:this.storeid,fromdate:this.fromdate,todate:this.todate,staffid:this.staffid}).then((res)=> {
        if (res.sucess) {
          if(res.object==null){
            this.staffCommDetals=[];  
          }
          else{
            this.staffCommDetals = res.object.staffCommDetalVos;
          }
        }
        else{
          this.$message.error(res.message);
        }
      });
    }
  }
}
</script>

<style style lang="scss" rel="stylesheet/scss">
  .page .el-table{
    font-size:10px;
  }
</style>




// WEBPACK FOOTER //
// src/page/hair/empperfdetal.vue